var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-slider" }, [
    _c("div", { ref: "heroSwiper", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        [
          _vm._l(_vm.images, function(image, index) {
            return _c("div", { key: index, staticClass: "swiper-slide" }, [
              _c("img", { attrs: { srcset: image } })
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-wrapper" }, [
            _c("h1", { domProps: { innerHTML: _vm._s(_vm.settings.title) } }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.settings.text))]),
            _vm._v(" "),
            _vm.settings.button_link && _vm.settings.button_label
              ? _c("a", { attrs: { href: _vm.settings.button_link } }, [
                  _vm._v(_vm._s(_vm.settings.button_label))
                ])
              : _vm._e()
          ])
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
    _vm._v(" "),
    _c("div", { ref: "next", staticClass: "swiper-button-next" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }